import React from 'react'
import { ICalendarRoom } from '../../../../BookingCalendar/Calendar/EventsGrid/EventsGrid'
import { IIntegrationsProps } from './Integrations'

const withLoadOnMount = <P extends ILoadRooms>(
  Component: React.ComponentType<P>,
) =>
  class WithLoadOnMount extends React.Component<P> {
    public componentWillMount() {
      if (this.props.rooms.length === 0) {
        this.props.loadRooms()
      }
    }

    public render() {
      return <Component {...this.props} />
    }
  }

export default withLoadOnMount

export interface ILoadRooms extends IIntegrationsProps {
  loadRooms?: () => void
  rooms?: ICalendarRoom[]
}
